import { useEffect, useCallback, useState } from "react";
import useAjax from "@apis/useAjax";
import { GET_PEOPLE_API } from "@apis/apiPath";
import { useSnackbar } from "notistack";

const usePeopleApi = targetType => {
	const Ajax = useAjax();
	const [people, setPeople] = useState([]);
	const [isLoaded, setIsLoaded] = useState(false);
	const { enqueueSnackbar } = useSnackbar();

	const getPeopleApi = useCallback(
		async type => {
			const resp = await Ajax.get(GET_PEOPLE_API, { type });
			if (!resp) enqueueSnackbar("失敗", { variant: "error" });
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	useEffect(
		() => {
			let isMounted = true;
			const fetchData = async () => {
				if (!targetType) return false;
				let resp = await getPeopleApi(targetType);
				if (resp) {
					isMounted && setPeople(resp);
					setIsLoaded(true);
				}
			};
			fetchData();
			return () => {
				// 防止元件卸載時不會更新狀態
				isMounted = false;
			};
		},
		// eslint-disable-next-line
		[targetType]
	);

	return { people, getPeopleApi, isLoaded };
};

export default usePeopleApi;
